import React from 'react';
import { useAtom } from 'jotai';
import { documentDataEditDialogIdAtom } from '../../../atoms/review-atoms';
import StatusEditDialog from '../../documents/StatusEditDialog';

const DocumentDataEditStatus: React.FC = () => {
  const [dialogData, setDialogData] = useAtom(documentDataEditDialogIdAtom);

  if (!dialogData) return null;

  return (
    <StatusEditDialog
      open={dialogData !== null}
      onClose={() => setDialogData(null)}
      documentId={dialogData.documentId}
      documentDataId={dialogData.id}
      currentDocumentDataStatus={dialogData.currentStatus}
      currentExclusionReason={dialogData.currentExclusionReason}
      currentEscalationDetail={dialogData.currentEscalationDetail}
    />
  );
};

export default DocumentDataEditStatus;
